export const getDisabledLinks = () => (process.env.REACT_APP_DISABLE_LINKS || "").split(",");
